import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';

export const careersFormSchema = z.object({
  fullName: z.string().trim().min(2, 'Please enter your full name'),
  phone: z
    .string()
    .trim()
    .min(7, 'Please enter a valid phone number')
    .regex(/^[+()\d\s-]+$/, 'Please enter a valid phone number'),
  email: z.string().trim().email('Please enter a valid email address'),
  speciality: z.string().trim().min(2, 'Please enter your speciality'),
  professionalTitle: z
    .string()
    .trim()
    .min(2, 'Please enter your professional title'),
});

export type CareersFormValues = z.infer<typeof careersFormSchema>;

export const careersFormDefaultValues: CareersFormValues = {
  fullName: '',
  phone: '',
  email: '',
  speciality: '',
  professionalTitle: '',
};

export const careersFormFields: FieldConfig[] = [
  {
    name: 'fullName',
    label: 'Full Name',
    type: 'text',
    placeholder: 'John Doe',
    required: true,
    colSpan: 1,
  },
  {
    name: 'phone',
    label: 'Phone',
    type: 'tel',
    placeholder: '+44 000 000 00',
    required: true,
    colSpan: 1,
  },
  {
    name: 'email',
    label: 'Email',
    type: 'email',
    placeholder: 'johndoe@gmail.com',
    required: true,
    colSpan: 2,
  },
  {
    name: 'speciality',
    label: 'Speciality',
    type: 'text',
    placeholder: 'Speciality',
    required: true,
    colSpan: 1,
  },
  {
    name: 'professionalTitle',
    label: 'Professional Title',
    type: 'text',
    placeholder: 'Professional Title',
    required: true,
    colSpan: 1,
  },
];
